import { useState, Fragment } from "react";
import { Outlet } from "react-router-dom";
import { Menu, Close, Phone, Place } from "@mui/icons-material";
import Logo from "../../assets/Logo.png";

import {
  TopBar,
  NavigationContainer,
  NavLinks,
  NavLink,
  LogoContainer,
  NavActions,
  CallButton,
  MobileMenuButton,
  MainContentContainer
} from "./navigation.styles";

const PHONE = "951-438-7540";
const PHONE_HREF = "tel:9514387540";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Service Areas", href: "#areas" },
  { label: "Why Us", href: "#why" },
  { label: "Reviews", href: "#reviews" }
];

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <Fragment>
      <TopBar>
        <div className="inner">
          <span className="areas">
            <Place style={{ fontSize: "1rem", verticalAlign: "-2px" }} />{" "}
            Serving Riverside, San Bernardino &amp; Orange County
          </span>
          <a className="topcall" href={PHONE_HREF}>
            Open 24/7 — <strong>{PHONE}</strong>
          </a>
        </div>
      </TopBar>

      <NavigationContainer>
        <LogoContainer to="/">
          <img
            src={Logo}
            alt="Xpress Rooter & Plumbing logo"
            className="logo"
          />
        </LogoContainer>

        <NavLinks $mobileMenuOpen={mobileMenuOpen}>
          {LINKS.map(link =>
            <NavLink
              key={link.href}
              href={link.href}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </NavLink>
          )}
        </NavLinks>

        <NavActions>
          <CallButton href={PHONE_HREF} aria-label={`Call us at ${PHONE}`}>
            <Phone fontSize="small" />
            <span className="label">
              {PHONE}
              <small>Tap to call 24/7</small>
            </span>
          </CallButton>
          <MobileMenuButton
            onClick={() => setMobileMenuOpen(open => !open)}
            aria-label="Toggle menu"
            aria-expanded={mobileMenuOpen}
          >
            {mobileMenuOpen ? <Close /> : <Menu />}
          </MobileMenuButton>
        </NavActions>
      </NavigationContainer>

      <MainContentContainer>
        <Outlet />
      </MainContentContainer>
    </Fragment>
  );
};

export default Navigation;
